/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./status-record-dialog.vue?vue&type=template&id=129b3865&scoped=true&"
import script from "./status-record-dialog.vue?vue&type=script&lang=ts&"
export * from "./status-record-dialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129b3865",
  null
  
)

export default component.exports